// extracted by mini-css-extract-plugin
export default {"page":"ContactUs_page__AfQFg","content":"ContactUs_content__W5Ehx","header":"ContactUs_header__hn35S","box":"ContactUs_box__i6BKV"};